import { useState } from 'react';
import {
  ErroredUploadSteps,
  UploadInspectionDataModalContext,
  UploadInspectionDataModalContextErrorState,
} from './UploadInspectionDataModalContext';
import { Steps, UploadTypes } from '../UploadInspectionDataModal';
import { AtlasGqlFileFormat, AtlasGqlInspectionType } from 'types/atlas-graphql';
import { MultipleInspectionValidationProps } from '../MultipleInspections';
import { SingleInspectionValidationProps } from '../SingleInspection';

interface UploadInspectionDataModalContextProviderProps {
  children: React.ReactNode;
}

export function UploadInspectionDataModalContextProvider({
  children,
}: UploadInspectionDataModalContextProviderProps) {
  const [alertState, setAlertState] = useState<UploadInspectionDataModalContextErrorState | null>(
    null
  );
  const [useFolderMethod, setUseFolderMethod] = useState<boolean>(false);
  const [pendingStep, setPendingStep] = useState<Steps | undefined>();
  const [erroredUploadSteps, setErroredUploadSteps] = useState<ErroredUploadSteps>({
    summary: false,
    imageDetails: false,
  });
  const [file, setFile] = useState<File | undefined>();
  const [providedFieldNames, setProvidedFieldNames] = useState<string[]>();
  const [previewData, setPreviewData] = useState<
    {
      [key: string]: string | number;
    }[]
  >();
  const [imageDetailsFileType, setImageDetailsFileType] = useState<AtlasGqlFileFormat>(
    AtlasGqlFileFormat.Csv
  );
  const [inspectionType, setInspectionType] = useState<AtlasGqlInspectionType>();
  const [createdInspectionIds, setCreatedInspectionIds] = useState<string[]>([]);
  const [createdTaskIds, setCreatedTaskIds] = useState<string[]>([]);

  const resetState = () => {
    setUseFolderMethod(false);
    setAlertState(null);
    setPendingStep(undefined);
    setFile(undefined);
  };

  const contextValue = {
    alertState,
    setAlertState,
    useFolderMethod,
    setUseFolderMethod,
    pendingStep,
    setPendingStep,
    erroredUploadSteps,
    setErroredUploadSteps,
    inspectionType,
    setInspectionType,
    createdInspectionIds,
    setCreatedInspectionIds,
    createdTaskIds,
    setCreatedTaskIds,
    imageDetailsContext: {
      file,
      providedFieldNames,
      setFile,
      setProvidedFieldNames,
      previewData,
      setPreviewData,
      imageDetailsFileType,
      setImageDetailsFileType,
    },
    resetState,
  };

  return (
    <UploadInspectionDataModalContext.Provider value={contextValue}>
      {children}
    </UploadInspectionDataModalContext.Provider>
  );
}
